import { supabaseAuthProvider } from "../../providers/supabase/auth";
import { supabase } from "../../providers/supabase/client"; // Solo para consultas CRUD directas mientras se migra el provider CRUD global.

import { logAuditEvent } from "../auditLog";

// Provider activo
const authProvider = supabaseAuthProvider;

export const login = async (email, password) => {
  const res = await authProvider.signIn(email, password);
  if (!res.error && res.data?.user) {
    try {
      await logAuditEvent({
        action: 'LOGIN',
        entityType: 'auth',
        entityId: res.data.user.id,
        metadata: { email: res.data.user.email }
      });
    } catch (_) {}
  }
  return res;
};

export const logout = async () => {
  try {
    sessionStorage.clear();
  } catch (_) {}
  try {
    const { data } = await authProvider.getUser();
    if (data?.user) {
      await logAuditEvent({
        action: 'LOGOUT',
        entityType: 'auth',
        entityId: data.user.id,
        metadata: { email: data.user.email }
      });
    }
  } catch (_) {}
  return await authProvider.signOut();
};

export const getCurrentUser = async () => {
  return await authProvider.getUser();
};

export const getSession = async () => {
  return await authProvider.getSession();
};

export const resetPassword = async (email, redirectTo) => {
  return await authProvider.resetPassword(email, redirectTo);
};

export const updatePassword = async (newPassword) => {
  return await authProvider.updateUser({ password: newPassword });
};

export const setSession = async (accessToken, refreshToken) => {
  return await authProvider.setSession(accessToken, refreshToken);
};

export const onAuthStateChange = (callback) => {
  return authProvider.onAuthStateChange(callback);
};

export const signUp = async (email, password, options = {}) => {
  return await authProvider.signUp(email, password, options);
};

// ─── LÓGICA DE PERFILES Y ROLES (DOMINIO AUTH) ───

/**
 * Actualiza la última fecha de login de un usuario
 */
export const updateLastLogin = async (userId) => {
  return await supabase
    .from("profiles")
    .update({ last_login_at: new Date().toISOString() })
    .eq("id", userId);
};

/**
 * Obtiene el perfil de un usuario
 */
export const getUserProfile = async (userId) => {
  return await supabase
    .from("profiles")
    .select("*")
    .eq("id", userId)
    .single();
};

/**
 * Obtiene todos los roles de sistema ordenados por creación
 */
export const getSystemRoles = async () => {
  return await supabase.from("system_roles").select("*").order("created_at");
};

/**
 * Crea un nuevo rol de sistema
 */
export const createSystemRole = async (roleData) => {
  return await supabase.from("system_roles").insert([roleData]);
};

/**
 * Actualiza un rol de sistema por su llave (key)
 */
export const updateSystemRole = async (key, roleData) => {
  return await supabase.from("system_roles").update(roleData).eq("key", key);
};

/**
 * Elimina un rol de sistema por su llave (key)
 */
export const deleteSystemRole = async (key) => {
  return await supabase.from("system_roles").delete().eq("key", key);
};

/**
 * Obtiene los permisos correspondientes a una lista de llaves de rol
 */
export const getSystemRolesPermissions = async (roleKeys) => {
  return await supabase
    .from("system_roles")
    .select("key, permissions")
    .in("key", roleKeys);
};

/**
 * Obtiene todos los perfiles de usuario ordenados por fecha de creación desc
 */
export const getAllProfiles = async () => {
  return await supabase.from("profiles").select("*").order("created_at", { ascending: false });
};

/**
 * Obtiene perfiles de usuario por una lista de IDs
 */
export const getProfilesByIds = async (userIds) => {
  return await supabase
    .from("profiles")
    .select("id, first_name, last_name, email")
    .in("id", userIds);
};

/**
 * Actualiza el perfil de un usuario
 */
export const updateProfile = async (userId, data) => {
  return await supabase.from("profiles").update(data).eq("id", userId).select().single();
};

/**
 * Registra o actualiza el perfil de un usuario
 */
export const upsertProfile = async (profileData) => {
  return await supabase.from("profiles").upsert(profileData, { onConflict: "id" });
};

/**
 * Transfiere activos y cartera de un usuario origen a un usuario destino
 */
export const transferUserAssets = async (sourceUserId, targetUserId) => {
  return await supabase.rpc("transfer_user_assets", {
    source_user_id: sourceUserId,
    target_user_id: targetUserId,
  });
};
